import type { ReactNode } from 'react';

export function Card({ title, children, className = '' }: { title?: string; children: ReactNode; className?: string }) {
  return (
    <section className={`glass-panel p-6 ${className}`}>
      {title ? <h3 className="font-display text-xl text-onyx-text mb-4">{title}</h3> : null}
      {children}
    </section>
  );
}
